import React, { useState } from 'react';
import { useLang } from '../i18n/LangContext';   // V147 중국어 화면이면 중국어 설명

// ── 탭별 튜토리얼 콘텐츠 ──────────────────────────────────────
export const TUTORIALS = {
  recipes: {
    title: '📋 레시피 관리',
    steps: [
      {
        icon: '🍱',
        title: '셈핏 레시피에 오신 것을 환영합니다!',
        desc: '레시피를 3가지 타입으로 체계적으로 관리할 수 있습니다.\n왼쪽 목록에서 선택하거나 + 버튼으로 새 레시피를 추가해보세요.',
      },
      {
        icon: '🛒',
        title: '원재료 (Raw Material)',
        desc: '실제 구매하는 식자재입니다.\n단가표 탭에서 가격을 등록하면 원가가 자동으로 계산됩니다.\n예) 간장, 돼지고기, 쌀, 마요네즈',
      },
      {
        icon: '🔄',
        title: '반제품 (Semi-Finished)',
        desc: '원재료를 조합해 미리 만들어두는 중간 단계 제품입니다.\n예) 특제 양념장, 기본 육수, 볶음 채소\n\n판매 메뉴에서 이 반제품을 재료로 사용할 수 있어요.',
      },
      {
        icon: '🍽️',
        title: '판매 메뉴 (Final Product)',
        desc: '고객에게 판매하는 완성 제품입니다.\n반제품과 원재료를 조합해 레시피를 구성해요.\n\n판매 가격을 입력하면 원가율이 자동으로 계산됩니다.',
      },
      {
        icon: '💰',
        title: '원가 자동 계산',
        desc: '단가표에 원재료 가격을 등록하면\n모든 레시피의 원가가 연쇄적으로 계산됩니다.\n\n반제품 → 판매 메뉴 순서로 원가가 자동 반영되어\n정확한 메뉴 원가율을 확인할 수 있습니다.',
      },
    ],
  },
  orders: {
    title: '👥 단체주문',
    steps: [
      {
        icon: '📝',
        title: '단체주문 수량 입력',
        desc: '메뉴별 판매 수량을 입력하면\n필요한 재료가 자동으로 계산됩니다.\n\n학교 급식, 도시락 납품, 행사 주문에 유용합니다.',
      },
      {
        icon: '📦',
        title: '발주서로 바로 연동',
        desc: '계산된 필요 수량을 바탕으로\n발주서 탭에서 바로 발주서를 작성할 수 있습니다.\n\n"발주서에 추가" 버튼을 눌러보세요.',
      },
    ],
  },
  purchase: {
    title: '📦 발주서',
    steps: [
      {
        icon: '🛒',
        title: '발주서 작성',
        desc: '필요한 식자재를 선택하고 수량을 입력해\n발주서를 빠르게 만들 수 있습니다.',
      },
      {
        icon: '🔢',
        title: '수량 자동 계산',
        desc: '단체주문 탭에서 메뉴 수량을 입력하면\n레시피 기반으로 필요한 재료량이\n자동으로 발주서에 채워집니다.',
      },
      {
        icon: '📋',
        title: '발주 내역 저장',
        desc: '발주서를 저장하면 날짜별 내역이 기록됩니다.\n재고관리 탭에서 월별 사용량 분석에 활용되고\n손익관리에서 식재료비 자동 집계도 가능해요.',
      },
    ],
  },
  receiving: {   // V158
    title: '📥 입고',
    steps: [
      {
        icon: '📦',
        title: '발주서를 누르면 그대로 채워져요',
        desc: '물건이 오면 입고 대기 발주서의 [입고]를 누르세요.\n주문한 품목·수량·단가가 채워집니다.\n\n영수증을 보면서 받은 양과 단가만 고치면 끝.\n안 온 품목은 [안 옴], 더 온 품목은 [＋ 품목 추가].',
      },
      {
        icon: '💰',
        title: '단가가 바뀌면 단가표도 같이',
        desc: '단가표와 값이 다르면 ▲▼로 알려줘요.\n저장할 때 체크된 품목은 단가표 단가도 바뀝니다.\n(원하지 않으면 체크를 끄세요)',
      },
      {
        icon: '📒',
        title: '외상 · 영수증 사진',
        desc: '결제를 외상으로 고르면 발주처별 외상 잔액에 쌓이고\n📒 외상 탭에서 한 번에 정산할 수 있어요.\n\n영수증 사진도 같이 저장해 두면 나중에 확인하기 쉬워요.\n이달 입고 합계는 운영 > 손익의 식재료비로 자동으로 들어갑니다.',
      },
    ],
  },
  prices: {
    title: '💰 단가표',
    steps: [
      {
        icon: '📝',
        title: '원재료 단가 등록',
        desc: '구매하는 식자재의 가격을 등록하면\n모든 레시피의 원가가 자동으로 계산됩니다.\n\n처음에는 예시 단가가 입력되어 있습니다.\n실제 구매 가격으로 수정해주세요.',
      },
      {
        icon: '📊',
        title: '입력 방법',
        desc: '품목명 · 규격(포장 단위) · 가격 · 내용량(g)을\n입력하면 됩니다.\n\n예) 간장 15L통 → 가격 45,000원, 내용량 14,500g\n→ 1g당 원가: 3.1원 (자동 계산)',
      },
      {
        icon: '🔄',
        title: '반제품 단가 자동 계산',
        desc: '반제품의 단가는 사용된 원재료 가격을 합산해\n자동으로 계산됩니다.\n\n원재료 가격을 업데이트하면\n연결된 반제품과 판매 메뉴 원가도 자동 반영됩니다.',
      },
    ],
  },
  profit: {
    title: '📊 손익관리',
    steps: [
      {
        icon: '📅',
        title: '월별 손익 입력',
        desc: '매월 매출과 비용을 입력해\n손익현황을 한눈에 확인합니다.\n\n상단 월 선택 버튼으로 원하는 월을 선택하세요.',
      },
      {
        icon: '💳',
        title: '매출 입력',
        desc: '카드매출 · 현금매출 · 배달매출을\n구분해 입력하면 총 매출이 자동 합산됩니다.',
      },
      {
        icon: '💸',
        title: '비용 입력',
        desc: '식재료비 · 인건비 · 임대료 · 공과금 · 기타 비용을\n입력합니다.\n\n📦 "발주 내역에서 자동 채우기" 버튼을 누르면\n이번 달 발주서 기반으로 식재료비가 자동 입력됩니다.',
      },
      {
        icon: '🤖',
        title: 'AI 손익 피드백',
        desc: '"AI 피드백" 버튼을 누르면\n원가율 · 인건비 비중 · 영업이익률을 분석해\n개선 조언을 제공합니다. (Pro 플랜)',
      },
    ],
  },
  inventory: {
    title: '🗃️ 재고관리',
    steps: [
      {
        icon: '📦',
        title: '재고 현황 관리',
        desc: '현재 보유 중인 재고량을 입력하고\n부족한 재료를 한눈에 파악합니다.\n\n매일 또는 주 1회 재고를 업데이트하면 효과적입니다.',
      },
      {
        icon: '📊',
        title: '적정 발주량 자동 계산',
        desc: '최근 3개월 발주 내역을 기반으로\n월평균 사용량을 자동 계산합니다.\n\n적정 발주량 = 월평균 사용량 × 1.5 − 현재 재고',
      },
      {
        icon: '🚨',
        title: '재고 상태 5단계 알림',
        desc: '재고 상태를 색상으로 한눈에 표시합니다.\n\n🚨 긴급 부족 → 🔴 부족 → ⚠️ 주의\n→ 🟡 적정 → ✅ 충분',
      },
    ],
  },
  work: {   // V149
    title: '✅ 오늘의 작업',
    steps: [
      {
        icon: '👆',
        title: '눌러서 오늘 할 일 만들기',
        desc: '왼쪽(모바일은 ＋ 버튼) 레시피를 누르면 오늘 목록에 들어갑니다.\n냉장고 정리처럼 레시피가 없는 일은 직접 적으면 돼요.',
      },
      {
        icon: '⚖️',
        title: '만들 양 → 재료 자동 계산',
        desc: '만들 양(g 또는 인분)을 적거나 ×½ ×1 ×2 ×3을 누르면\n그 양에 맞는 재료가 바로 계산됩니다.\n\n반제품 재료 옆 「+ 작업」을 누르면 그 반제품 만들기도 같이 들어가요.',
      },
      {
        icon: '✅',
        title: '체크하고 발주서처럼 저장',
        desc: '다 한 일은 체크 — 누가 몇 시에 했는지 같이 남습니다.\n\n💾 저장을 누르면 날짜별 내역에 쌓이고,\n📅 내역에서 예전 목록을 다시 불러올 수 있어요.',
      },
      {   // V155 · V156
        icon: '🗓',
        title: '순서 · 다음 날 · 회의 · 위챗',
        desc: '줄 왼쪽 ⠿를 잡고 끌면 순서가 바뀌어요.\n체크하면 그날 내역에 저장되고 목록에서 빠져요 (잘못 눌렀으면 ↩ 되돌리기).\n안 한 작업은 다음 날에도 남아요.\n\n🗓 회의 탭은 적는 대로 자동 저장돼요.\n테스크(담당자·마감일)를 적으면 바로 오늘의 작업에 들어가요.\n💬 위챗으로 한국어+중국어 글을 보낼 수 있어요.',
      },
    ],
  },
  tax: {
    title: '🏛️ 세무회계',
    steps: [
      {
        icon: '📅',
        title: '신고 마감일 D-day 확인',
        desc: '부가세 · 종합소득세 · 원천세\n신고 마감일을 카운트다운으로 알려드립니다.\n\n기한을 놓치면 가산세가 발생할 수 있으니\n미리 확인하세요!',
      },
      {
        icon: '💰',
        title: '부가세 자동 계산',
        desc: '손익관리 매출 데이터를 연동해\n예상 부가세 납부액을 자동 계산합니다.\n\n매입세액 공제 항목을 꼼꼼히 입력할수록\n납부세액이 줄어듭니다.',
      },
      {
        icon: '📋',
        title: '홈택스 신고 단계별 가이드',
        desc: '각 세금 탭에서 "홈택스 신고 가이드" 버튼을\n누르면 단계별 안내가 펼쳐집니다.\n\n처음 신고하시는 분도 따라 하실 수 있어요.',
      },
      {
        icon: '👥',
        title: '원천세 관리',
        desc: '직원(9.4%) 또는 프리랜서(3.3%) 원천세를\n자동 계산합니다.\n\n매월 10일까지 신고·납부해야 합니다.',
      },
    ],
  },
};

// ── V147: 중국어 화면용 — 중국 매장 직원 기준으로 다시 쓴 설명 ──────────────────
export const TUTORIALS_ZH = {
  recipes: {
    title: '📋 配方',
    steps: [
      { icon: '🍱', title: '配方分三种',
        desc: '在左边列表选择配方，或点 + 添加新配方。\n\n🛒 原料：买来的食材（酱油、猪肉、大米……）\n🔄 半成品：先做好的酱料、高汤等\n🍽️ 菜品：卖给客人的菜' },
      { icon: '💰', title: '成本自动计算',
        desc: '单价表里登记了食材价格，配方成本就会自动算出来。\n\n半成品 → 菜品，成本会一层层自动更新。\n填上售价，成本率也会自动计算。' },
    ],
  },
  orders: {
    title: '👥 团体订单',
    steps: [
      { icon: '📝', title: '按菜品数量算食材',
        desc: '填写每道菜要做多少份，需要的食材用量会自动算出来。\n\n算好后可以直接加到订货单。' },
    ],
  },
  purchase: {
    title: '📦 订货单',
    steps: [
      { icon: '🛒', title: '点食材，填数量',
        desc: '在左边列表点食材，就会加到右边的订货单。\n\n数量 1 = 一个规格\n（例：土豆 规格 10斤 → 数量 1 就是 10斤）' },
      { icon: '🏪', title: '按供应商分开保存',
        desc: '保存时会按供应商分成几张订货单。\n\n点「发微信」会复制订货单文字，\n直接粘贴到微信发给供应商。' },
      { icon: '📅', title: '订货记录',
        desc: '保存过的订货单在「查看记录」里。\n\n数量填错了可以修改，\n几张订货单也可以合并成一张。' },
    ],
  },
  receiving: {   // V158
    title: '📥 入库',
    steps: [
      { icon: '📦', title: '点订货单，自动填好',
        desc: '货到了，点待入库订货单的「入库」。\n订的食材、数量、单价都会自动填好。\n\n对着送货单改实收数量和单价就行。\n没送的点「没送」，多送的点「＋ 添加食材」。' },
      { icon: '💰', title: '价格变了，单价表一起改',
        desc: '和单价表不一样会显示 ▲▼。\n保存时勾选的食材会同时更新单价表。' },
      { icon: '📒', title: '赊账 · 送货单照片',
        desc: '付款选「赊账」会按供应商累计赊账余额，\n在 📒 赊账 页可以一起结清。\n\n送货单照片也可以一起保存。' },
    ],
  },
  prices: {
    title: '💰 单价表',
    steps: [
      { icon: '📝', title: '登记食材价格',
        desc: '填写 品名 · 规格 · 单位 · 价格 · 净重(g) · 供应商。\n\n价格登记好，所有配方的成本都会自动计算。' },
      { icon: '🔄', title: '价格变了就改这里',
        desc: '这里的价格一改，\n用到这个食材的半成品和菜品成本都会自动更新。' },
    ],
  },
  profit: {
    title: '📊 运营',
    steps: [
      { icon: '📅', title: '每月营业额和成本',
        desc: '按月填写营业额和各项成本，\n利润和利润率会自动计算。\n\n上面的月份按钮可以切换月份。' },
    ],
  },
  inventory: {
    title: '🗃️ 库存管理',
    steps: [
      { icon: '📦', title: '填写现在的库存',
        desc: '每天或每周更新一次库存，\n缺少的食材一眼就能看到。' },
      { icon: '📊', title: '建议订货量',
        desc: '根据最近的订货记录和配方，自动算出建议订货量，\n可以一键加到订货单。\n\n🚨 紧急不足 → 🔴 不足 → ⚠️ 注意 → 🟡 适量 → ✅ 充足' },
    ],
  },
  work: {   // V149
    title: '✅ 今日工作',
    steps: [
      { icon: '👆', title: '点一下，做出今天的工作清单',
        desc: '在左边（手机点 ＋ 按钮）点配方，就会加到今日清单。\n整理冰箱这种没有配方的工作，直接写就行。' },
      { icon: '⚖️', title: '填要做的量，用料自动算',
        desc: '填要做的量（g 或 份），或者点 ×½ ×1 ×2 ×3，\n需要的食材用量马上算出来。\n\n半成品用料旁边点「+ 工作」，做这个半成品也会一起加进来。' },
      { icon: '✅', title: '做完打勾，像订货单一样保存',
        desc: '做完的打勾 —— 谁、几点做的都会记下来。\n\n点 💾 保存，就按日期记到记录里，\n在「📅 记录」里可以再调出以前的清单。' },
      { icon: '🗓', title: '排序 · 第二天 · 会议 · 微信',   // V155 · V156
        desc: '按住左边的 ⠿ 拖动就能调整顺序。\n打勾后会存到当天的记录，并从清单里消失（点错了可以 ↩ 撤回）。\n没做完的第二天还会留着。\n\n🗓 会议 写的内容会自动保存。\n写好任务（负责人·截止日期）就会马上加到今日工作。\n点 💬 微信 可以发韩中文字。' },
    ],
  },
  tax: {
    title: '🏛️ 税务会计',
    steps: [
      { icon: '🇰🇷', title: '韩国报税用的功能',
        desc: '这里是韩国门店报税用的（增值税、综合所得税、代扣税等）。\n\n中国门店一般用不到，有问题请问老板。' },
    ],
  },
};

// ── 튜토리얼 모달 컴포넌트 ────────────────────────────────────
export default function TutorialModal({ tabId, onClose }) {
  const { lang } = useLang();
  const L = (ko, zh) => (lang === 'zh' ? zh : ko);
  const [step, setStep] = useState(0);
  const tutorial = (lang === 'zh' && TUTORIALS_ZH[tabId]) || TUTORIALS[tabId];

  if (!tutorial) return null;

  const steps = tutorial.steps;
  const cur   = steps[Math.min(step, steps.length - 1)];   // V147 언어를 바꾸면 단계 수가 달라질 수 있다
  const isLast = step >= steps.length - 1;

  return (
    <div
      style={{
        position: 'fixed', inset: 0, zIndex: 10000,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: 'rgba(0,0,0,0.55)', padding: '16px',
        animation: 'fadeIn 0.2s ease',
      }}
      onClick={onClose}
    >
      <style>{`
        @keyframes fadeIn  { from { opacity: 0 } to { opacity: 1 } }
        @keyframes slideUp { from { transform: translateY(18px); opacity: 0 } to { transform: translateY(0); opacity: 1 } }
      `}</style>

      <div
        style={{
          background: '#fff', borderRadius: '22px',
          padding: '32px 28px 24px',
          maxWidth: '400px', width: '100%',
          boxShadow: '0 24px 64px rgba(0,0,0,0.25)',
          position: 'relative',
          animation: 'slideUp 0.25s ease',
        }}
        onClick={e => e.stopPropagation()}
      >
        {/* 닫기 버튼 */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute', top: '14px', right: '14px',
            border: 'none', background: '#f3f4f6', color: '#6b7280',
            width: '28px', height: '28px', borderRadius: '50%',
            fontSize: '14px', cursor: 'pointer', lineHeight: 1,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>✕</button>

        {/* 탭 이름 뱃지 */}
        <div style={{
          fontSize: '12px', fontWeight: '800', color: '#18181B',
          background: '#FAFAFA', padding: '5px 12px', borderRadius: '20px',
          display: 'inline-block', marginBottom: '20px',
          border: '1px solid #F4F4F5',
        }}>
          {tutorial.title} — {step + 1}/{steps.length}
        </div>

        {/* 아이콘 */}
        <div style={{ fontSize: '54px', textAlign: 'center', marginBottom: '14px', lineHeight: 1 }}>
          {cur.icon}
        </div>

        {/* 제목 */}
        <h3 style={{
          fontSize: '17px', fontWeight: '800', color: '#111827',
          textAlign: 'center', marginBottom: '12px', lineHeight: 1.4,
        }}>
          {cur.title}
        </h3>

        {/* 설명 */}
        <p style={{
          fontSize: '13.5px', color: '#4b5563', lineHeight: 1.85,
          textAlign: 'center', whiteSpace: 'pre-line', marginBottom: '24px',
        }}>
          {cur.desc}
        </p>

        {/* 진행 dots */}
        <div style={{ display: 'flex', justifyContent: 'center', gap: '6px', marginBottom: '20px' }}>
          {steps.map((_, i) => (
            <div
              key={i}
              onClick={() => setStep(i)}
              style={{
                width: i === step ? '22px' : '8px', height: '8px',
                borderRadius: '4px', cursor: 'pointer',
                background: i === step ? '#FF6F0F' : '#e5e7eb',
                transition: 'all 0.2s',
              }}
            />
          ))}
        </div>

        {/* 버튼 */}
        <div style={{ display: 'flex', gap: '8px' }}>
          {step > 0 && (
            <button
              onClick={() => setStep(s => s - 1)}
              style={{
                flex: 1, padding: '12px', borderRadius: '10px',
                border: '1.5px solid #e5e7eb', background: '#fff',
                fontSize: '14px', fontWeight: '700', cursor: 'pointer', color: '#374151',
              }}>
              {L('← 이전', '← 上一步')}
            </button>
          )}
          <button
            onClick={isLast ? onClose : () => setStep(s => s + 1)}
            style={{
              flex: 2, padding: '12px', borderRadius: '10px',
              border: 'none', background: '#FF6F0F', color: '#fff',
              fontSize: '14px', fontWeight: '800', cursor: 'pointer',
            }}>
            {isLast ? L('✅ 시작하기!', '✅ 开始使用！') : L('다음 →', '下一步 →')}
          </button>
        </div>

        {/* 건너뛰기 */}
        {!isLast && (
          <p
            onClick={onClose}
            style={{
              textAlign: 'center', fontSize: '12px', color: '#9ca3af',
              marginTop: '12px', cursor: 'pointer',
            }}>
            {L('건너뛰기', '跳过')}
          </p>
        )}
      </div>
    </div>
  );
}

// ── 튜토리얼 표시 여부 관리 헬퍼 ─────────────────────────────
const LS_PREFIX = 'ddabak_tutorial_';

export function hasTutorial(tabId) {
  return !!TUTORIALS[tabId];
}

export function isFirstVisit(tabId) {
  return !localStorage.getItem(LS_PREFIX + tabId);
}

export function markTutorialSeen(tabId) {
  localStorage.setItem(LS_PREFIX + tabId, '1');
}

export function resetAllTutorials() {
  Object.keys(TUTORIALS).forEach(id => localStorage.removeItem(LS_PREFIX + id));
}
